// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3-8Q0","rootSmall":"AddTileButton_rootSmall__1qRnq"};